var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({zoom:_vm.scaleValue}),attrs:{"id":"app"}},[_c('navigation'),_c('router-view'),(_vm.footerShow)?_c('footerDom'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }